export default {"src":"https://s.sylndr.com/c-3ffd4af/_next/static/media/HamburgerIcon.19bcc28c.svg","height":14,"width":20,"blurWidth":0,"blurHeight":0};